import type { FC } from 'react';

interface Props {
  className?: string;
}

const PackageLockersIcon: FC<Props> = ({ className = 'w-5 h-5 mr-1' }) => {
  return (
    <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M9 1L5 3l4 2 4-2-4-2z"
      />
      <rect x="8" y="12" width="8" height="6" rx="1" strokeWidth="2" />
      <circle cx="12" cy="15" r="1" fill="currentColor" />
    </svg>
  );
};

export default PackageLockersIcon;
